import "UI/Renderer/EJS";

NS("UI");

UI.Template = new Static({
    renderer: null,

    render: function(name, args) {
        var html = "";

        try {
            html = (this.renderer && name) ? this.renderer.render(name, args) : "";
        } catch (e) {
            console.error('ERROR render("' + name + '")');
            console.log(e);
            console.trace();

            throw e;
        }

        return html;
    },

    $render: function(name, args) {
        return $(this.render(name, args));
    }
});
